import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/app/layouts";
import { ProtectedRoute } from "@/app/routes/protected";
import { NotFoundPage } from "@/components/common";
import { PATHS } from "@/lib/router";
import { authRoutes } from "@/features/auth";
import { dashboardRoutes } from "@/features/dashboard";
import { esgDashboardRoutes } from "@/features/esg-dashboard-v3";
import { userManagementRoutes } from "@/features/user-management";
import { companyRoutes } from "@/features/company";
import { organizationRoutes } from "@/features/organization";
import { onboardingRoutes } from "@/features/onboarding";
import { moreSolutionsRoutes } from "@/features/more-solutions";
import { activityLogRoutes } from "@/features/activity-log";
import { settingsRoutes } from "@/features/settings";
import { surveysRoutes, surveysPublicRoutes } from "@/features/surveys";
import { notificationsRoutes } from "@/features/notifications";
import { esgPublicRoutes, esgRoutes } from "@/features/esg";
import { dataEntryRoutes } from "@/features/data-entry/routes";
import { targetSetupRoutes } from "@/features/target-setup/routes";
import { carbonInventoryRoutes } from "@/features/carbon-inventory";
import { billOcrRoutes } from "@/features/bill-ocr/routes";
import { customFrameworkRoutes } from "@/features/custom-framework";
import { RouteGuard } from "./route-guard";
import { gElementRoutes } from "@/features/g-element/routes";
import {
  surveyLibraryPublicRoutes,
  surveyManagementRoutes,
} from "@/features/survey-management";
import { callForHelpRoutes } from "@/features/call-for-help";

// Compose all feature routes
const routes = [
  ...authRoutes,
  ...surveysPublicRoutes,
  ...esgPublicRoutes,
  ...surveyLibraryPublicRoutes,
  {
    element: (
      <ProtectedRoute>
        <RouteGuard>
          <AppLayout />
        </RouteGuard>
      </ProtectedRoute>
    ),
    children: [
      ...dashboardRoutes,
      ...esgDashboardRoutes,
      ...userManagementRoutes,
      ...companyRoutes,
      ...organizationRoutes,
      ...onboardingRoutes,
      ...moreSolutionsRoutes,
      ...settingsRoutes,
      ...activityLogRoutes,
      ...notificationsRoutes,
      ...surveysRoutes,
      ...esgRoutes,
      ...dataEntryRoutes,
      ...targetSetupRoutes,
      ...carbonInventoryRoutes,
      ...billOcrRoutes,
      ...customFrameworkRoutes,
      ...gElementRoutes,
      ...surveyManagementRoutes,
      ...callForHelpRoutes,
    ],
  },
  {
    path: PATHS.NOT_FOUND,
    element: <NotFoundPage />,
  },
];

// Create router instance
export const router = createBrowserRouter(routes);
